module.exports = __webpack_public_path__ + "static/media/skull.6852deae.png";